import { post } from "../api";
import { UserModel } from "./models/UserModel";

export const searchUser = async (query: string): Promise<UserModel[]> => {
    return await post({
        url: `/admin/users/search`,
        body: { query },
    });
};
